
import { Component, Vue, Prop } from "vue-property-decorator";
import RegisterForm from "@shared/components/login/registerForm.vue";
import Popup from "@shared/components/popup/popup.vue";
import { CustomerHelper } from "@shared/crm/helpers/customerHelper";

@Component({
  components: {
    RegisterForm,
    Popup,
  },
})
export default class DependentCustomers extends Vue {
  @Prop() parentCustomerId!: number;

  showRegisterForm = false;
  customer: any = { children: [] };

  showDeletePopup = false;
  childIdToDelete: number | null = null;

  async mounted() {
    await this.fetchCustomer();
  }

  async fetchCustomer() {
    const cid = this.parentCustomerId || CustomerHelper.getStoredCustomer();
    if (!cid) return;
    this.customer = await CustomerHelper.getCustomerData(cid);
  }

  async goBackToList() {
    this.showRegisterForm = false;
    await this.fetchCustomer();
  }

  openDeleteModal(childId: number) {
    this.childIdToDelete = childId;
    this.showDeletePopup = true;
  }

  async confirmDelete() {
    if (this.childIdToDelete && this.customer?.id) {
      const success = await CustomerHelper.unlinkChild(this.customer.id, this.childIdToDelete);
      if (success) {
        await this.fetchCustomer();
      }
    }
    this.cancelDelete();
  }

  cancelDelete() {
    this.showDeletePopup = false;
    this.childIdToDelete = null;
  }
}
